module.exports = __webpack_public_path__ + "static/fipcbiglovehamp-46825b2b4b4d1bb9c1385faa10f4561c.jpeg";